import request from "./request";
/**
 * 解除绑定
 * @param id 用户id
 */
export default async function unbindUser(data) {
  return await request.post("/spin/dataAuthorizationPlayer/unbindUser", data);
}
